import { useGetIndexes, useGetUiAdminConfigWritePermissions } from '@cs-cms/state-management';
import { GLOBAL_FILTERS_LIMIT_KEY_PREFIX, MULTI_FILE_UPLOAD_LIMIT_KEY_PREFIX } from '@cs-cms/types';

export const useConfigurationKeysManagementPermissions = (indexId?: number | null) => {
  const { data: indexes } = useGetIndexes();
  const globalFiltersLimitKeys = indexes
    ? indexes.map(index => `${GLOBAL_FILTERS_LIMIT_KEY_PREFIX}${index.id}`)
    : undefined;

  const multiFileUploadLimitKeys = indexes
    ? indexes.map(index => `${MULTI_FILE_UPLOAD_LIMIT_KEY_PREFIX}${index.id}`)
    : undefined;

  const summedKeys = [...(globalFiltersLimitKeys ?? []), ...(multiFileUploadLimitKeys ?? [])];
  const { data: writePermissions, isLoading: isLoadingPermissions } = useGetUiAdminConfigWritePermissions(summedKeys);

  if (indexes === undefined || writePermissions === undefined) {
    return { canEditAnything: false, canEditGlobalFiltersLimit: false, isLoadingPermissions: true };
  }

  const canEditAnything = summedKeys.some(key => writePermissions[key] === true);

  if (indexId === null || indexId === undefined) {
    return { canEditAnything, canEditGlobalFiltersLimit: false, isLoadingPermissions: false };
  }

  const currentGlobalFiltersLimitKey = `${GLOBAL_FILTERS_LIMIT_KEY_PREFIX}${indexId}`;

  const canEditGlobalFiltersLimit = writePermissions[currentGlobalFiltersLimitKey] === true;

  const currentMultiFileUploadLimitKey = `${MULTI_FILE_UPLOAD_LIMIT_KEY_PREFIX}${indexId}`;

  const canEditMultiFileUploadLimit = writePermissions[currentMultiFileUploadLimitKey] === true;

  return { canEditAnything, canEditGlobalFiltersLimit, canEditMultiFileUploadLimit, isLoadingPermissions };
};
